"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("../../config");
var ai_use_case_1 = require("../types/ai-use-case");
var buildReadinessPath = function (workflowId, useCaseId) {
    return "/ai/" + encodeURIComponent(workflowId) + "/use-cases/" + encodeURIComponent(useCaseId) + "/readiness";
};
var toPercentage = function (rawScore) {
    return Math.round(Math.max(0, Math.min(1, rawScore)) * 10000) / 100;
};
var toElementIdList = function (rawValue) {
    if (!Array.isArray(rawValue)) {
        return [];
    }
    return rawValue
        .filter(function (value) { return typeof value === 'string'; })
        .map(function (value) { return value.trim().toLowerCase(); })
        .filter(function (value) { return value.length > 0; });
};
var getElementsCollection = function (payload, preferredKey) {
    if (Array.isArray(payload)) {
        return payload;
    }
    if (!payload || typeof payload !== 'object') {
        return [];
    }
    var record = payload;
    var preferred = record[preferredKey];
    if (Array.isArray(preferred)) {
        return preferred;
    }
    var fallbackKey = preferredKey === 'elementDetails' ? 'elements' : 'elementDetails';
    var fallback = record[fallbackKey];
    if (Array.isArray(fallback)) {
        return fallback;
    }
    return [];
};
var toElementDetails = function (rawValue) {
    if (!Array.isArray(rawValue)) {
        return [];
    }
    var uniqueItems = new Map();
    rawValue.forEach(function (rawItem) {
        if (!rawItem || typeof rawItem !== 'object') {
            return;
        }
        var record = rawItem;
        var idValue = typeof record.id === 'string' ? record.id.trim().toLowerCase() : '';
        var nameValue = typeof record.name === 'string' ? record.name.trim() : '';
        var typeValue = typeof record.type === 'string' ? record.type.trim().toLowerCase() : undefined;
        var isReadyValue = typeof record.isReady === 'boolean' ? record.isReady : undefined;
        if (idValue.length === 0) {
            return;
        }
        uniqueItems.set(idValue, {
            id: idValue,
            name: nameValue.length > 0 ? nameValue : idValue,
            type: typeValue,
            isReady: isReadyValue,
        });
    });
    return Array.from(uniqueItems.values());
};
/**
 * Persist selected readiness elements for a single use case.
 */
var aiHubReadinessApiService = {
    getUseCaseElements: function (workflowId, useCaseId) { return __awaiter(void 0, void 0, void 0, function () {
        var apiGet, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiGet = config_1.getApiGet();
                    return [4 /*yield*/, apiGet("/ai/" + encodeURIComponent(workflowId) + "/use-cases/" + encodeURIComponent(useCaseId) + "/elements")];
                case 1:
                    result = (_a.sent());
                    return [2 /*return*/, toElementIdList(getElementsCollection(result, 'elements'))];
            }
        });
    }); },
    getUseCaseElementDetails: function (workflowId, useCaseId) { return __awaiter(void 0, void 0, void 0, function () {
        var apiGet, result, details;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiGet = config_1.getApiGet();
                    return [4 /*yield*/, apiGet("/ai/" + encodeURIComponent(workflowId) + "/use-cases/" + encodeURIComponent(useCaseId) + "/elements")];
                case 1:
                    result = (_a.sent());
                    details = toElementDetails(getElementsCollection(result, 'elementDetails'));
                    if (details.length > 0) {
                        return [2 /*return*/, details];
                    }
                    return [2 /*return*/, toElementIdList(getElementsCollection(result, 'elements')).map(function (id) { return ({
                            id: id,
                            name: id,
                        }); })];
            }
        });
    }); },
    getUseCaseReadinessScore: function (workflowId, useCaseId) { return __awaiter(void 0, void 0, void 0, function () {
        var apiGet, result, rawScore;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiGet = config_1.getApiGet();
                    return [4 /*yield*/, apiGet(buildReadinessPath(workflowId, useCaseId))];
                case 1:
                    result = (_a.sent());
                    rawScore = typeof (result === null || result === void 0 ? void 0 : result.readinessScore) === 'number' ? result.readinessScore : 0;
                    return [2 /*return*/, toPercentage(rawScore)];
            }
        });
    }); },
    updateUseCaseReadiness: function (workflowId, useCaseId, readinessElementIds) { return __awaiter(void 0, void 0, void 0, function () {
        var apiPut, payload, result, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    apiPut = config_1.getApiPut();
                    payload = readinessElementIds
                        .map(function (value) { return value.trim(); })
                        .filter(function (value) { return value.length > 0; });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiPut(buildReadinessPath(workflowId, useCaseId), payload)];
                case 2:
                    result = (_b.sent());
                    if (!result || typeof result !== 'object') {
                        throw new Error('Readiness endpoint returned an empty response');
                    }
                    if (result.id === undefined || result.id === null || !result.fields) {
                        throw new Error('Readiness endpoint returned an invalid use case payload');
                    }
                    return [2 /*return*/, ai_use_case_1.normalizeAiUseCase(result)];
                case 3:
                    error_1 = _b.sent();
                    if (process.env.NODE_ENV !== 'production') {
                        // eslint-disable-next-line no-console
                        console.error('Error updating readiness values:', (_a = error_1) === null || _a === void 0 ? void 0 : _a.message);
                    }
                    throw error_1;
                case 4: return [2 /*return*/];
            }
        });
    }); },
    markElementReady: function (elementId) { return __awaiter(void 0, void 0, void 0, function () {
        var apiPatch;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiPatch = config_1.getApiPatch();
                    return [4 /*yield*/, apiPatch("/ai/elements/" + encodeURIComponent(elementId) + "/ready", {})];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); },
    markElementUnready: function (elementId) { return __awaiter(void 0, void 0, void 0, function () {
        var apiPatch;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiPatch = config_1.getApiPatch();
                    return [4 /*yield*/, apiPatch("/ai/elements/" + encodeURIComponent(elementId) + "/unready", {})];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); },
};
exports.default = aiHubReadinessApiService;
